import { render } from "./admin-login.vue?vue&type=template&id=4d913d45"
import script from "./admin-login.vue?vue&type=script&lang=js"
export * from "./admin-login.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__